import './css/CookingCustomerDetail.css'

import { useEffect, useMemo, useState, Fragment } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Button, Space } from 'antd'
import { baseAxiosNoInfo } from '../../tool/axios'
import getPermission from '../../js/permission'

import AddDiningReception from './components/AddDiningReception'
import AddDieticianAssess from './components/AddDieticianAssess'
import AddDieticianCheck from './components/AddDieticianCheck'

import CustomerInfo from './components/CustomerInfo'
import CustomerCheckInInfo from './components/CustomerCheckInInfo'
import CustomerBabyInfo from './components/CustomerBabyInfo'
import CustomerServiceInfo from './components/CustomerServiceInfo'

import RecordDiningReception from './components/RecordDiningReception'
import RecordDieticianAssess from './components/RecordDieticianAssess'
import RecordDieticianCheck from './components/RecordDieticianCheck'

interface Client {
    check_in_id: string //入住id
    check_in_user_name: string //客人姓名
    check_in_phone: string //手机号码
    preg_status_desc: string //怀孕时期
    expect_born_day: string //预产期（预计入住时间）
    actually_born_day: string //分娩日
    check_in_time: string //实际入住时间
    check_out_time_init: string //预计出所时间
    check_out_time_finally: string //实际出所时间
    emergency_man_name: string //紧急联系人
    emergency_phone: string //紧急联系人手机号
    accompany_man_name: string //陪护人
    accompany_phone: string //陪护人手机号
    deal_item_name: string //签单套餐名称
    check_in_total_days: number //入住总天数，整数类型
    check_in_already_days: number //已入住天数，整数类型
    check_in_left_days: number //剩余天数，整数类型
    item_days: number //套餐入住天数，整数类型
    gift_days: number //赠送天数，整数类型
    deal_records_remark: string //签单备注
    store_id: string //签单门店id
    deal_prov_pic_list: string //合同凭证图片
    already_notify: number // 是否通知入住 0未通知 1已通知，整数类型，当为1时候前端点击“通知入住”需要调用“入住客户管理-已预订-查询通知信息”接口填充各个字段且禁用各个字段
    check_in_status: number  //0待分配 1已预订 2已入住 3已出所
    current_room_number: string // 当前入住房号，可能为空
}
interface checkInRecordData {
    room_number: string,
    check_in_day_range: string,
    room_type_name: string
}

interface person {
    check_in_id: string
    belong_minion_id: string //责任管家id
    belong_minion_name: string // 责任管家名称
    belong_cleaner_id: string // 生活助理（保洁）id
    belong_cleaner_name: string // 生活助理（保洁）名称
    belong_nurse_id: string // 责任护士id
    belong_nurse_name: string // 责任护士名称，冗余字段
    belong_dietician_id: string // 营养师id
    belong_dietician_name: string // 营养师名称
    belong_recover_id: string // 产康师id
    belong_recover_name: string // 产康师名称
    belong_look_after_id: string // 护理师id
    belong_look_after_name: string // 护理师名称
}
export default function () {

    const [tabCurrent, setTabCurrent] = useState<number>(0)
    const [clientData, setClientData] = useState<Client>()
    const param: { check_in_id: string } = useParams()
    const [statusStr, setStatusStr] = useState<string>('')
    const [checkInRecordData, setCheckInRecordData] = useState<checkInRecordData[]>([])
    const [servicedata, setServiceData] = useState<person>()

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    const getServiceInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/service_employee_info', {
            params: {
                check_in_id: param.check_in_id
            }
        }).then((res: any) => {
            res && setServiceData(res)
        })
    }

    const getCheckInRecord = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/room_info', {
            params: {
                check_in_id: param.check_in_id
            }
        }).then((res: any) => {
            if (res) {
                setCheckInRecordData(res)
            }
        })
    }

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.check_in_id
            }
        }).then((res: any) => {
            if (res) {
                switch (res.check_in_status) {
                    case 0:
                        setStatusStr('待分配')
                        break
                    case 1:
                        setStatusStr('已预订')
                        break
                    case 2:
                        setStatusStr('已入住')
                        break
                    case 3:
                        setStatusStr('已出所')
                        break
                    case 4:
                        setStatusStr('续住中')
                        break
                }
                setClientData(res)
            }
        })
    }

    useEffect(() => {
        getClientInfo()
        getCheckInRecord()
        getServiceInfo()
    }, [])

    return <div className="common-level2-edit h-detail">
        {/* 膳食中心 -> 营养膳食 -> 入住客户管理 -> 客户详情 */}
        <p className="modules-h2">客户详情</p>

        <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
            <Button size="small" onClick={() => { window.history.go(-1) }} >返回</Button>
        </div>

        {/* 已预定 */}
        {clientData?.check_in_status === 1 && <Fragment>
            <Link style={{ marginLeft: 32, marginBottom: 16 }} to={'/cooking_customer_dining_detail/' + param.check_in_id} >客户餐单</Link>
            <Link style={{ marginLeft: 32, marginBottom: 16 }} to={'/cooking_customer_today_dining/' + param.check_in_id} >每日排餐</Link><Space>
            </Space>
        </Fragment>}

        {/* 已入住 */}
        {clientData?.check_in_status === 2 && <Fragment>
            <Link style={{ marginLeft: 32, marginBottom: 16 }} to={'/cooking_customer_dining_detail/' + param.check_in_id} >客户餐单</Link>
            <Link style={{ marginLeft: 32, marginBottom: 16 }} to={'/cooking_customer_today_dining/' + param.check_in_id} >每日排餐</Link>
            <Space>
                {/* 随餐接单 */}
                <AddDiningReception />
                {/* 营养评估 */}
                <AddDieticianAssess />
                {/* 营养师查房 */}
                <AddDieticianCheck />
            </Space>
        </Fragment>}

        {/* 已出所 */}
        {clientData?.check_in_status === 3 && <Fragment>
            <Link style={{ marginLeft: 32, marginBottom: 16 }} to={'/cooking_customer_dining_detail/' + param.check_in_id} >客户餐单</Link>
        </Fragment>}

        {/* 客户信息 */}
        <CustomerInfo status={statusStr} data={clientData} onChange={() => {
            getClientInfo()
        }} />
        {/* 入住信息 */}
        {clientData?.check_in_status !== 0 && <CustomerCheckInInfo data={checkInRecordData} />}
        {/* 宝宝信息 */}
        <CustomerBabyInfo customerID={param.check_in_id} />
        {/* 服务人员信息 */}
        <CustomerServiceInfo serviceData={servicedata} storeID={clientData?.store_id} onChange={() => {
            getClientInfo()
        }} />

        <div className="tab clear">
            {clientData?.check_in_status != 1 && <Fragment>
                <div className={tabCurrent === 0 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(0) }}>随餐接待记录</div>
                <div className={tabCurrent === 1 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(1) }}>营养评估记录</div>
                <div className={tabCurrent === 2 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(2) }}>营养师查房记录</div>
            </Fragment>}
        </div>

        <div className="tab-cont">
            {tabCurrent === 0 ? <div className="cont">
                <RecordDiningReception />
            </div> : null}
            {tabCurrent === 1 ? <div className="cont">
                <RecordDieticianAssess />
            </div> : null}
            {tabCurrent === 2 ? <div className="cont">
                <RecordDieticianCheck />
            </div> : null}
        </div>
    </div>
}